export const FEATURED_PROJECTS_URL =
  'https://api.github.com/users/guilhermeportella/repos?sort=pushed&per_page=3';
